import { rModelsBase } from './.catalog';

export class rOyakKiraBilgileriUstBilgi extends rModelsBase {
  toplam_kiraya_verilen: number;
  toplam_yillik_gelir: number;
  toplam_aylik_gelir: number;
  yil: string;
  ay: string;

  constructor() {
    super();
    this.toplam_kiraya_verilen = 0;
    this.toplam_yillik_gelir = 0;
    this.toplam_aylik_gelir = 0;
    this.yil = '';
    this.ay = '';
  }
}
